import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 合并 Tailwind 类名。
 *
 * 为什么不能只用模板字符串拼：`'px-2' + ' ' + 'px-4'` 两个类会同时存在，
 * 谁生效取决于**它们在生成的 CSS 里的先后**，而不是这里的顺序 —— 于是
 * 「组件里给了 px-2，调用方传 px-4 想覆盖」有时生效有时不生效。
 * `twMerge` 认识 Tailwind 的类族，会把前面的同族类真正删掉。
 *
 * 所有 `components/ui/` 下的组件都必须用它来拼 `props.class`，
 * 否则调用方无法覆盖组件的默认样式。
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
